<template>
  <component
    :is="filterComponent"
    ref="innerFilter"
    :pager="pager"
    @change="onChange"
    @page-change="onPageChange"
  />
</template>

<script>
import SearchMusicTagsFilter from './SearchMusicTagsFilter.vue'
import SearchSoundTagsFilter from './SearchSoundTagsFilter.vue'
import SearchVideoTagsFilter from './SearchVideoTagsFilter.vue'
import SearchPictureTagsFilter from './SearchPictureTagsFilter.vue'

const FILTER_MAP = {
  2: 'SearchMusicTagsFilter',
  3: 'SearchSoundTagsFilter',
  4: 'SearchVideoTagsFilter',
  5: 'SearchPictureTagsFilter'
}

export default {
  name: 'SearchTagsFilter',
  components: {
    SearchMusicTagsFilter,
    SearchSoundTagsFilter,
    SearchVideoTagsFilter,
    SearchPictureTagsFilter
  },
  props: {
    materialType: {
      type: Number,
      default: 2
    },
    pager: {
      type: Object,
      default: () => ({ page: 1, limit: 12, total: 0 })
    }
  },
  computed: {
    filterComponent() {
      return FILTER_MAP[this.materialType] || 'SearchMusicTagsFilter'
    }
  },
  methods: {
    onChange(payload) {
      this.$emit('change', payload || {})
    },
    onPageChange(payload) {
      this.$emit('page-change', payload)
    },
    cleanTagSearch() {
      const inner = this.$refs.innerFilter
      if (inner && typeof inner.cleanTagSearch === 'function') {
        inner.cleanTagSearch()
      }
    }
  }
}
</script>
